/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const Desktop: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.5003 15.0023H12.4957C12.771 15.0023 12.9945 15.2258 12.9945 15.5012C12.9945 15.7765 12.771 15.9999 12.4957 16H3.51638C3.24106 16 3.01753 15.7765 3.01753 15.5012C3.01753 15.2258 3.24106 15.0023 3.51638 15.0023H5.51178L7.00832 12.5081H9.00372L10.5003 15.0023ZM14.0418 0.0374137C15.0603 0.0753263 15.9487 0.954199 15.987 1.98268C16.0204 4.67602 16.0204 7.37 15.987 10.0633C15.9491 11.0819 15.0702 11.9703 14.0418 12.0086C10.0182 12.0585 5.99381 12.0585 1.97029 12.0086C0.951693 11.9707 0.0632915 11.0918 0.0250298 10.0633C-0.00834326 7.37 -0.00834326 4.67602 0.0250298 1.98268C0.0629922 0.962929 0.941267 0.0757254 1.97029 0.0374137C5.99381 -0.0124712 10.0182 -0.0124712 14.0418 0.0374137ZM14.9953 9.01611C15.0226 6.51373 15.021 4.50965 14.9895 2.00732C14.9707 1.4961 14.5313 1.05412 14.017 1.03491C10.0203 0.985577 6.02295 1.03451 2.02596 1.03451C1.49988 1.041 1.04183 1.48288 1.02253 2.00732C0.991002 4.50965 0.988558 6.51373 1.01594 9.01611H14.9953Z'
			/>
		</Svg>
	);
};

export { Desktop };
